// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7951cfac","239":"e054a739","455":"d6c4f7fe"}[chunkId] + ".chunk.js";
};